module.exports = __webpack_public_path__ + "img/fwdw_02.257fb83e.jpg";